export function getFloatingButtonStyle(shouldApplyPosition: boolean, right: number, bottom: number) {
    if (!shouldApplyPosition) {
        return '';
    }

    return `right: ${right}px; bottom: ${bottom}px;`;
}

export function getOfferHelpTooltipStyle(shouldApplyPosition: boolean, right: number, bottom: number, verticalOffset: number) {
    if (!shouldApplyPosition) {
        return '';
    }

    return `right: ${right}px; bottom: ${bottom + verticalOffset}px;`;
}

export function getContainerStyle(isMinimized: boolean, shouldApplyPosition: boolean, right: number) {
    const styleRules: string[] = [];

    if (isMinimized) {
        styleRules.push('display: none;');
    }

    if (shouldApplyPosition) {
        styleRules.push(`right: ${right}px;`);
    }

    return styleRules.join(' ');
}
